import React, {useState, useEffect} from 'react'
import './buttonlist.scss';


const ButtonList = () => {
	
	const [buttondata, setButtondata] = useState ([]);
	const [buttonListData, setButtonListData] = useState ([])
	
	const getAllButtonData = async () => {
		try {
			const response = await fetch ('data/uielements.json');
			if (!response.ok) {
				throw new Error ('Failed to fetch data');
			}
			const data = await response.json ();
			
			const FilterButtonList = data.UIElements?.filter ((uicode) => uicode.UIElementId === "UIElemetBtn");
			
			setButtonListData (FilterButtonList || []);
			
		} catch (err) {
			console.error ('Error fetching button data:', err);
		}
	}
	
	useEffect (() => {
		getAllButtonData ();
	}, []);
	
	const handleDownloadUIElement = (file) => {
		const link = document.createElement ('a');
		link.href = file;
		link.download = file.split ('/').pop (); // Extract file name from path
		document.body.appendChild (link);
		link.click ();
		document.body.removeChild (link);
	};
	
	
	return (
		<>
			<div className="mainButtonList">
				<div className="subButtonList">
					{
						buttonListData.length === 0 ? (
							<p>Loading...</p>
						) : (
							buttonListData.map ((item, index) => (
								<div className="ButtonList" key={index}>
									<div className="ButtonListUIElements-image-box">
										<img src={item.VideoGif} alt=""/>
									</div>
									<div className="ButtonInfo">
										<div className="title">{item.title}</div>
										<p>{item.Developer}</p>
										<div className="mainDownloadBtn">
											<button className='DownloadBtn' onClick={() => handleDownloadUIElement (item.ZipFile)}>Download</button>
										</div>
									</div>
								</div>
							)))
					}
				</div>
			</div>
		</>
	)
}

export default ButtonList